import Settings from '../components/modules/settings';

const setting = [
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      title: 'Settings',
      requiresAuth: true,
    },
  },
];

export default setting;
